import DataTable from "../dataTable/DataTable";
import { edit as grabbersList } from '../../slices/grabbersSelectedSlice';
import { appUrl } from "../../utils/fetch";
import ImportVideo from "./ImportVideo";
import "./GrabbersList.css";
import TubeSubmit from "../form/TubeSubmit";
import { useEffect, useState } from "react";
import DialogComponent from "../dialog/Dialog";
import GrabbersSourceDialog from "./GrabbersSourceDialog";
import { edit as grabbersSource } from '../../slices/grabbersSourceSlice';
import { edit as createGrabber} from '../../slices/importSlice';
import { useDispatch, useSelector } from 'react-redux';
import HistoryList from "./HistoryList";
import { useNavigate, useParams } from "react-router-dom";

function GrabbersList() {
    const navigate = useNavigate();
    const { tab } = useParams();
    const [isGrabberDialogOpen, setIsGrabberDialogOpen] = useState(false);
    const [historyDialog, setHistoryDialog] = useState({
        isOpen: false,
        id: 0
    });
    const [ forceRefresh, setForceRefresh ] = useState(false);
    const [ autoRefresh, setAutoRefresh ] = useState(false);
    const dispatch = useDispatch();
    const grabber = useSelector((state) => state.import);

    const handleOpenSource = (row) => {
        dispatch(grabbersSource({id: row.id, isOpen: true, platform: row.platform, source: "" }));
    }

    useEffect(() => {
        if(tab === "import"){
            setAutoRefresh(true);
        }
        else {
            setAutoRefresh(false);
        }
    }, [tab]);

    return (
        <div>
            <DataTable 
                autoRefresh={autoRefresh}
                forceRefresh={forceRefresh}
                dataUrl={`${appUrl}/api/grabbers`}
                deleteUrl={`${appUrl}/api/grabber-delete`}
                editUrl={`/grabber`}
                url={"/grabbers"}
                actions={(
                    <TubeSubmit
                        label="Create new grabber"
                        onClick={() => {
                            setIsGrabberDialogOpen(true);
                            dispatch(createGrabber("default"));
                        }}
                    />
                )}
                editComponentIsLoading={grabber.isLoading}
                editComponent={(id, closeFunc = () => {}) => {
                    return (<ImportVideo id={id} closeFunc={closeFunc}/>)
                }}
                editMaxWidth={900}
                selectedStateName="grabbersSelected"
                dispatchFunc={grabbersList}
                extraUtils={[
                    { 
                        label: "History",
                        icon: "history",
                        onClick: (row) => {
                            setHistoryDialog({
                                isOpen: true,
                                id: row.id
                            });
                            navigate("/videos/import/history/page/1")
                        }
                    }
                ]}
                header={{
                    id: {
                        label: "ID",
                        field: "text"
                    },
                    platform: {
                        label: "Grabber",
                        field: "text"
                    },
                    description: {
                        label: "Description",
                        field: "text"
                    },
                    process: { 
                        label: "Process",
                        field: "html"
                    },
                    importType: {
                        label: "Method",
                        field: "text"
                    },
                    status: {
                        label: "Status",
                        field: "text",
                        conditionalClass: {
                            content: "Offline",
                            className: "videos-list-status-offline"
                        }
                    },
                    type: {
                        label: "Accessibility",
                        field: "text"
                    },
                    duplicated: {
                        label: "Duplicated",
                        field: "text"
                    },
                    data: {
                        label: "Imported data",
                        field: "text"
                    },
                    utils: {
                        label: "",
                        field: "html",
                        onClick: (row) => handleOpenSource(row)
                    },
                    extraRow: {
                        content: (id) => {
                            return (
                                <GrabbersSourceDialog id={id} onConfirm={() => setForceRefresh(prevState => !prevState)}/>
                            )
                        }
                    }
                }}
            />
            <DialogComponent
                content={(
                    <ImportVideo
                        closeFunc={() => setIsGrabberDialogOpen(false)}
                    />
                )}
                open={isGrabberDialogOpen}
                maxWidth={900}
                onClose={() => setIsGrabberDialogOpen(false)}
                buttons={[
                    {
                        variant: "outlined",
                        label: "Delete",
                        color: "secondary",
                        disabled: true,
                        onClick: () => {dispatch(createGrabber("default"))},
                    },
                    {
                        variant: "outlined",
                        label: "Cancel",
                        color: "secondary",
                        onClick: () => setIsGrabberDialogOpen(false),
                    }
                ]}
                form={true}
            />
            <DialogComponent
                content={(
                    <HistoryList id={historyDialog.id} />
                )}
                open={historyDialog.isOpen}
                className={"history-dialog"}
                onClose={() => setHistoryDialog({isOpen: false, id: 0})}
                buttons={[
                    {
                        variant: "outlined",
                        label: "Close",
                        color: "secondary",
                        onClick: () => setHistoryDialog({isOpen: false, id: 0}),
                    }
                ]}
            />
        </div>
    );
}

export default GrabbersList;